export default __webpack_public_path__ + "static/media/prev-icon.06a4f316.svg";